<template>
  <div>
    <section v-if="loaded" class="video-show">
      <video-show
        ref="videoShowRef"
        v-bind="$attrs"
      />
    </section>
    <div v-else>
      <div class="spinner-wrapper">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { nextTick } from 'vue'
import $ from 'jquery'
import VideoShow from './show/video-show.vue'
import { useProvideVideoShow } from './use-video-show'

export default {
  name: 'Show',
  components: {
    VideoShow
  },
  inheritAttrs: false,
  props: {
    videoId: {
      required: true
    }
  },
  setup () {
    useProvideVideoShow()
  },
  data () {
    return {
      loaded: false,
      video: null,
      profile: null,
      playlist: null
    }
  },
  mounted () {
    this.loadVideo()
  },
  methods: {
    loadVideo () {
      axios.get(this.router('api.video.show', { video: this.videoId }))
        .then(resp => {
          this.profile = resp.data.profile
          this.video = resp.data.video
          this.playlist = resp.data.playlist
          this.loaded = true
          if (!this.video.switches.display_page_header) {
            $('body').addClass('header-hidden')
          }
          nextTick(() => {
            this.$refs.videoShowRef.assignData(this.video, this.profile, this.playlist)
          })
        })
    }
  }
}
</script>

<style scoped lang="scss">
.spinner-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #cfcfcf;
  opacity: 0.3;
}
</style>
